var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signature__content"},[_c('div',{staticClass:"heading"},[_vm._v("Assinatura")]),_c('div',{staticClass:"signature"},[_c('img',{attrs:{"width":"200","height":"auto","src":_vm.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }